import { render, staticRenderFns } from "./DataModal.vue?vue&type=template&id=3cd17f28&"
import script from "./DataModal.vue?vue&type=script&lang=js&"
export * from "./DataModal.vue?vue&type=script&lang=js&"
import style0 from "./DataModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports